import { render, staticRenderFns } from "./SecKillOrderPane.vue?vue&type=template&id=1a63ae06&scoped=true"
import script from "./SecKillOrderPane.vue?vue&type=script&lang=js"
export * from "./SecKillOrderPane.vue?vue&type=script&lang=js"
import style0 from "./SecKillOrderPane.vue?vue&type=style&index=0&id=1a63ae06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a63ae06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a63ae06')) {
      api.createRecord('1a63ae06', component.options)
    } else {
      api.reload('1a63ae06', component.options)
    }
    module.hot.accept("./SecKillOrderPane.vue?vue&type=template&id=1a63ae06&scoped=true", function () {
      api.rerender('1a63ae06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/secKill/SecKillOrderPane.vue"
export default component.exports